import React from 'react';
import './GettingStartedSection.css';

export default function Cards() {
  const ROW_1 = [
  'Source A1',
  'Source A2',
  'Source A3',
  'Source A4',
  'Source A5',
];

const ROW_2 = [
  'Source B1',
  'Source B2',
  'Source B3',
  'Source B4',
  'Source B5',
];

const ROW_3 = [
  'Source C1',
  'Source C2',
  'Source C3',
  'Source C4',
  'Source C5',
];

function SourceChip({ label }) {
  return (
    <div className="source-pill">
      <span className="chip-icon" />
      {label}
    </div>
  );
}

  return (
    <section className="getting-started">
      <h2 className="getting-started__title">Placeholder. Lorem. Ipsum.</h2>

      <div className="getting-started__cards">
        {/* Card 1 */}
        <div className="gs-card">
          <div className="gs-card__visual gs-card__visual--runtime">
            <div className="runtime-icons">
              <div className="runtime-icon docker" />
              <div className="runtime-icon jar">.jar</div>
              <div className="runtime-icon cloud" />
            </div>
          </div>

          <p className="gs-card__text">Lorem ipsum dolor sit {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}<a href="#">amet consectetur adipisicing elit</a>. Iure molestias quisquam, laboriosam itaque quaerat facere aspernatur. Unde commodi laboriosam expedita esse rerum quis officia</p>
        </div>

        {/* Card 2 */}
        <div className="gs-card">
          <div className="gs-card__visual gs-card__visual--sources gs-animate-sources">
  <div className="source-row slow">
    {ROW_1.map((s) => (
      <SourceChip key={s} label={s} />
    ))}
  </div>

  <div className="source-row medium">
    {ROW_2.map((s) => (
      <SourceChip key={s} label={s} />
    ))}
  </div>

  <div className="source-row fast">
    {ROW_3.map((s) => (
      <SourceChip key={s} label={s} />
    ))}
  </div>
</div>


          <p className="gs-card__text">{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}<a href="#">Lorem ipsum dolor sit</a> amet consectetur adipisicing elit. Iure molestias quisquam, laboriosam itaque quaerat facere aspernatur. {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}<a href="#">Unde commodi</a> laboriosam expedita esse rerum quis officia</p>
        </div>

        {/* Card 3 */}
        <div className="gs-card">
          <div className="gs-card__visual gs-card__visual--opensource">
            <div className="github-pill">
              <span className="github-icon" />
              45k+
            </div>
          </div>
          <p className="gs-card__text">Lorem ipsum {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}<a href="#">dolor sit amet</a> consectetur {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}<a href="#">adipisicing elit</a>. Iure molestias quisquam, laboriosam itaque quaerat facere aspernatur. Unde commodi laboriosam expedita esse rerum quis officia</p>
        </div>
      </div>
    </section>
  );
}
